import { Pipe, PipeTransform } from '@angular/core'
import { fullDayWithTime } from 'src/utils'
import { Customer } from '../customers-nav.queries'

@Pipe({
  name: 'tooltipCopy'
})
export class TooltipCopyPipe implements PipeTransform {
  dateInAMonth = this._getDateInAMonth()

  transform(customer: Customer, ...args: unknown[]): string {
    const nextCreditsDate = customer.subscription?.nextCreditsIssuedAt ?? this.dateInAMonth
    const endDate = new Date(nextCreditsDate)

    return `Managed by Verblio Valet until ${fullDayWithTime(endDate, true)}`
  }

  private _getDateInAMonth(): Date {
    const today = new Date()
    return new Date(today.setMonth(today.getMonth() + 1))
  }

}
